export default __webpack_public_path__ + "static/sustainability_FSC-af897edbb9506a1f93cb3cda898994ce.svg";